import { SpinnerService } from './spinner.service';
import { Component } from '@angular/core';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    imports: []
})
export class SpinnerComponent {
  public get showSpinner() {
    return this.spinnerService.showSpinner;
  }
  constructor(private spinnerService: SpinnerService) { }
}
